import React, { Component } from "react";
import SectionHeader from "../sectionHeader/sectionHeader";

class Review extends Component {
  constructor(props) {
    super();

    this.state = {
      reviews: [
        {
          image: "sandeep",
          review:
            "With Duomly, learning seems to be much easier. I can understand everything with great theory courses and build real-life projects next.",
          name: "Sandeep",
        },
        {
          image: "qiang",
          review:
            "Learning with Duomly is awesome. All courses are ordered in career paths, and I know what to do step by step.",
          name: "Qiang",
        },
        {
          image: "patricia",
          review:
            "Learning with Duomly is great! I can learn new skills and have a lot of fun at the same time.",
          name: "Patricia",
        },
      ],
    };
  }

  render() {
    const { reviews } = this.state;
    return (
      <div id="reviews">
        <div className="container">
          <SectionHeader
            title="What they said about us"
            subtitle="Check what our students say about "
            greenText="Duomly!"
          />
          <div className="row reviews-container">
            {reviews.map((review, index) => {
              return (
                <div className="col col-4" key={index}>
                  <div className="img-circle">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        `/img/oldLanding/${review.image}.jpg`
                      }
                      alt="duomly-review"
                    />
                  </div>
                  <p>"{review.review}"</p>
                  <p className="sign">- {review.name}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Review;
